"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _PageSizeContext = require("../contexts/PageSizeContext");

require("../styles/_section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Section(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      icon = _ref.icon,
      emptyText = _ref.emptyText,
      id = _ref.id,
      gotoId = _ref.gotoId,
      setRef = _ref.setRef;
  return /*#__PURE__*/_react.default.createElement(_PageSizeContext.PageSizeConsumer, null, function (_ref2) {
    var containerSize = _ref2.containerSize;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('section', {
        'section--medium': containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium + 1
      }),
      id: gotoId,
      ref: setRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "section__overview"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      heading3: true,
      noMargin: "top",
      prefixIcon: icon
    }, title), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      placeholder: true,
      className: "section__description"
    }, description)), /*#__PURE__*/_react.default.createElement("div", {
      className: "section__content",
      id: id
    }, children && !(0, _lodash.default)(children) ? children : /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
      rounded: true,
      className: "section__content__empty"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      placeholder: true
    }, emptyText))));
  });
}

var _default = (0, _react.memo)(Section);

exports.default = _default;